'use client'

import { featureFlagKeys } from 'feature-flags/constants/featureFlags'
import { useFeatureFlag } from 'feature-flags/hooks/useFeatureFlag/useFeatureFlag'
import { ButtonContentLink, LINK_SIZE } from 'fukku/Button/ContentLink'
import { ButtonSecondary } from 'fukku/Button/Secondary'
import { useResponsive } from 'hooks/useResponsive/useResponsive'

import { useColors } from '../../contexts/ColorsProvider/ColorsProvider'
import {
	type CustomizationContextType,
	useCustomization,
} from '../../contexts/CustomizationProvider/CustomizationProvider'
import { useSizes } from '../../contexts/SizesProvider/SizesProvider'
import type { PdpFeatureFlags } from '../../types/FeatureFlags'

import styles from './Customization.module.scss'

export interface CustomizationProps {
	asButtonLinkWithText?: boolean
}

export function Customization({
	asButtonLinkWithText = false,
}: CustomizationProps): React.ReactNode {
	const {
		variables: {
			config: { customizable },
		},
	} = useFeatureFlag<PdpFeatureFlags>(featureFlagKeys.GenesisPdp)
	const { isLargeOrGreater } = useResponsive()

	const { selectedColor } = useColors()
	const { selectedSize, setHasErrorMessage, openSheet } = useSizes()
	const { setIsCustomizationOpen } =
		useCustomization() as CustomizationContextType

	const onCustomizationClick = (): void => {
		if (selectedSize) {
			setIsCustomizationOpen(true)
		} else if (!isLargeOrGreater) {
			openSheet(true)
		} else {
			setHasErrorMessage(true)
		}
	}

	if (selectedColor.isSellable && selectedColor.customizable && customizable) {
		if (asButtonLinkWithText && isLargeOrGreater) {
			return (
				<div className={styles.customization}>
					<p className={styles.title}>
						Personalización <span className={styles.tag}>¡Nuevo!</span>
					</p>
					<p className={styles.description}>
						Elige tu bordado favorito y crea diseños únicos
					</p>
					<ButtonContentLink onClick={onCustomizationClick} size={LINK_SIZE.S}>
						Añadir bordado
					</ButtonContentLink>
				</div>
			)
		}

		if (!asButtonLinkWithText && !isLargeOrGreater) {
			return (
				<ButtonSecondary onClick={onCustomizationClick}>
					Personalizar
				</ButtonSecondary>
			)
		}
	}

	return null
}
